// extracted by mini-css-extract-plugin
export default {"SecondaryButton":"SecondaryButton__SecondaryButton___avY1s"};